import env from 'config/env';

export const kClientId = env.sso.clientId;
export const kAuthRoot = env.sso.authRoot;
export const kWebRoot = env.sso.webRoot;
export const kScope = env.sso.scope;
export const kCookieKey = 'ssoAuthParams';
export const kAuthPath = 'connect/authorize';
export const kApiStartPath = 'api/session/start';
export const kApiEndPath = 'api/session/end';
export const kResponseType = 'code';
export const kImpersonationFlagKey = 'impersonationFlag';
export const kCodeVerifierKey = 'codeVerifier';
export const kCodeChallengeMethod = 'S256';



// WEBPACK FOOTER //
// ./src/sso-auth/constants.js